import {Component, ElementRef, OnInit, ViewChild} from '@angular/core';
import {OrganisationResponse, OrganisationService} from '@cas-hub/acabim-common-client';
import {OrganisationSettingsService} from '../../_services/organisation/organisation-settings.service';
import {OrganisationSeatsComponent} from './organisation-seats/organisation-seats.component';

@Component({
    selector: 'acabim-admin-organisation',
    templateUrl: './organisation.component.html',
    styleUrls: ['./organisation.component.scss']
})
export class OrganisationComponent implements OnInit {

    @ViewChild('imgBrowser') public imageBrowseComponent!: ElementRef;
    @ViewChild('seatsView', {static: false}) public seatView?: OrganisationSeatsComponent;

    public isUploadingLogo = false;

    public currentOrganisation?: OrganisationResponse;
    public orgNameEditMode = false;

    constructor(
        private readonly organisationService: OrganisationService,
        private readonly organisationSettingsService: OrganisationSettingsService
    ) {}

    public ngOnInit(): void {
        this.organisationService.getCurrentOrganisationDetails().subscribe(data => {
            this.currentOrganisation = data;
        });
    }

    public onOrganisationNameChanged(name: string): void {
        if (this.currentOrganisation?.name !== name) {
            this.organisationSettingsService.changeName(name).subscribe(undefined, undefined, () => {
                if (this.currentOrganisation) {
                    this.currentOrganisation = {...this.currentOrganisation, name};
                }

                this.orgNameEditMode = false;
            });
        } else {
            this.orgNameEditMode = false;
        }
    }

    public requestToChangeLogo(): void {
        this.imageBrowseComponent.nativeElement.click();
    }

    public organisationLogoChangeHandler(event: any): void {
        const file = event.target.files.length > 0 ? event.target.files[0] : undefined;
        if (file) {
            this.isUploadingLogo = true;
            this.organisationSettingsService.changeLogo(file).subscribe(val => this.currentOrganisation = val,
                    _ => this.isUploadingLogo = false, () => this.isUploadingLogo = false);
        }
    }
}
